module.exports = __WEBPACK_EXTERNAL_MODULE_next_auth_react_207416fa__;